import React, { useState } from 'react';
import { Routes, Route, Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import './EducatoareDashboard.css';

// Educatoare Components
import EducatoareHome from './EducatoareHome';
import ComandaNoua from './ComandaNoua';
import ComenziMele from './ComenziMele';

const EducatoareDashboard = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [activeMenu, setActiveMenu] = useState('home');

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  return (
    <div className="educatoare-dashboard">
      <aside className="sidebar">
        <div className="sidebar-header">
          <h2>🍽️ Gradi</h2>
          <p className="user-info">{user?.nume}</p>
          <p className="clasa-info">
            {user?.clasa?.numeGradinita}<br/>
            <strong>{user?.clasa?.numeClasa}</strong>
          </p>
        </div>

        <nav className="sidebar-menu">
          <Link 
            to="/educatoare" 
            className={activeMenu === 'home' ? 'menu-item active' : 'menu-item'}
            onClick={() => setActiveMenu('home')}
          >
            <span>🏠</span> Acasă
          </Link>
          <Link 
            to="/educatoare/comanda-noua" 
            className={activeMenu === 'comanda' ? 'menu-item active' : 'menu-item'}
            onClick={() => setActiveMenu('comanda')}
          >
            <span>➕</span> Comandă Nouă
          </Link>
          <Link 
            to="/educatoare/comenzile-mele" 
            className={activeMenu === 'comenzi' ? 'menu-item active' : 'menu-item'}
            onClick={() => setActiveMenu('comenzi')}
          >
            <span>📋</span> Comenzile Mele
          </Link>
        </nav>

        <div className="sidebar-footer">
          <button onClick={handleLogout} className="btn btn-danger btn-block">
            Deconectare
          </button>
        </div>
      </aside>

      <main className="main-content">
        <Routes>
          <Route path="/" element={<EducatoareHome />} />
          <Route path="/comanda-noua" element={<ComandaNoua />} />
          <Route path="/comenzile-mele" element={<ComenziMele />} />
        </Routes>
      </main>
    </div>
  );
};

export default EducatoareDashboard;
